import axios from "utils/axios";

export const getCompanyDetails = (companyId) =>
  new Promise((resolve, reject) => {
    axios
      .get(`company/getcompany?companyId=${companyId}`)
      .then((response) => {
        // PRODUCTION-GRADE: Validate response
        if (response?.data?.success === false || !response?.data?.data || response?.data?.data.length === 0) {
          const error = new Error(response?.data?.message || 'Company not found');
          error.response = { status: 404, data: response?.data };
          reject(error);
          return;
        }
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const getAdminDetails = (companyId) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/company/admin/company/${companyId}`)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// export const updateCompanyDetails = (companyId) =>
//   new Promise((resolve, reject) => {
//     axios
//       .patch(`company/update/${companyId}`)
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });

export const updateCompanyDetails = (companyId, data) =>
  new Promise((resolve, reject) => {
    axios
      .patch(`company/update/${companyId}`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const updateCompanyPublishData = (companyId, data) =>
  new Promise((resolve, reject) => {
    axios
      .patch(`/company/update/unpublish/${companyId}`, data)
      .then((response) => resolve(response?.data))
      .catch((error) => reject(error));
  });

export const uploadCompanySceneProfileVideo = (companyId, data) =>
  new Promise((resolve, reject) => {
    axios
      .post(`/company/upload/profile_video/${companyId}`, data)
      .then((response) => resolve(response?.data))
      .catch((error) => reject(error));
  });

export const getCompanyList = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`/company/getcompany/list`)
      .then((response) => resolve(response?.data))
      .catch((error) => reject(error));
  });

 
  
